module.exports = __webpack_public_path__ + "p4_img3.jpg?1725cd97aa3cb4d0f63b9288913465ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img3.jpg
// module id = 110
// module chunks = 0